import React, { useState, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createNotification, NewNotificationData } from '../../../services/notificationService';
import { getUsersForSelection, UserSelectionData } from '../../../services/userService';
import { NotificationType } from '../../../types/enums';
// (1) !! استيراد ملف التنسيقات المشترك !!
import formStyles from './NotificationForm.module.css'; 

const AddNotificationPage: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [users, setUsers] = useState<UserSelectionData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const { register, handleSubmit, formState: { errors } } = useForm<NewNotificationData>();

  useEffect(() => {
    getUsersForSelection()
      .then(setUsers)
      .catch(() => toast.error('فشل في جلب قائمة المستخدمين.'))
      .finally(() => setIsLoading(false));
  }, []);

  const onSubmit: SubmitHandler<NewNotificationData> = (data) => {
    setIsSubmitting(true);
    const promise = createNotification(data);
    toast.promise(promise, {
      loading: 'جاري إرسال التنبيه...',
      success: () => {
        navigate('/admin/notifications/list');
        return 'تم إرسال التنبيه بنجاح!';
      },
      error: (err) => {
        setIsSubmitting(false);
        return err.response?.data?.message || 'فشل في إرسال التنبيه.';
      },
    });
  };

  if (isLoading) {
    return (
      <div className={formStyles.pageContainer}>
        <div className={formStyles.formContainer}>
          <p>جاري تحميل قائمة المستخدمين...</p>
        </div>
      </div>
    );
  }

  return (
    // (2) !! تطبيق نفس بنية HTML والـ CSS Classes !!
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>إرسال تنبيه جديد</h2>
        <form onSubmit={handleSubmit(onSubmit)} className={formStyles.form}>
          
          {/* حقل اختيار المستخدم */}
          <div className={formStyles.formField}>
            <label htmlFor="user_id" className={formStyles.label}>إرسال إلى المستخدم</label>
            <select 
              id="user_id" 
              {...register('user_id', { required: 'يجب اختيار مستخدم', valueAsNumber: true })} 
              className={formStyles.input}
            >
              <option value="">-- اختر مستخدماً --</option>
              {users.map(user => (
                <option key={user.id} value={user.id}>{user.email} ({user.role})</option>
              ))}
            </select>
            {errors.user_id && <p className={formStyles.error}>{errors.user_id.message}</p>}
          </div>

          {/* حقل نوع التنبيه */}
          <div className={formStyles.formField}>
            <label htmlFor="type" className={formStyles.label}>نوع التنبيه</label>
            <select 
              id="type" 
              {...register('type', { required: true })} 
              className={formStyles.input}
            >
              <option value={NotificationType.IN_APP}>داخل التطبيق</option>
              <option value={NotificationType.SMS}>رسالة نصية (SMS)</option>
            </select>
          </div>

          {/* حقل العنوان */}
          <div className={formStyles.formField}>
            <label htmlFor="title" className={formStyles.label}>العنوان</label>
            <input 
              id="title" 
              {...register('title', { required: 'العنوان مطلوب' })} 
              className={formStyles.input} 
            />
            {errors.title && <p className={formStyles.error}>{errors.title.message}</p>}
          </div>

          {/* حقل نص الرسالة */}
          <div className={formStyles.formField}>
            <label htmlFor="message" className={formStyles.label}>نص الرسالة</label>
            <textarea 
              id="message" 
              {...register('message', { required: 'نص الرسالة مطلوب' })} 
              className={formStyles.input} 
              rows={5}
            ></textarea>
            {errors.message && <p className={formStyles.error}>{errors.message.message}</p>}
          </div>

          {/* حاوية الأزرار */}
          <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`}>
            <Link to="/admin/notifications/list" className={formStyles.cancelButton}>إلغاء</Link>
            <button type="submit" disabled={isSubmitting} className={formStyles.submitButton}>
              {isSubmitting ? 'جاري الإرسال...' : 'إرسال التنبيه'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNotificationPage;
